export default __webpack_public_path__ + "static/media/solucao-06.79a50a33.webp";